import {generalRankingKeysType, generalRankings, rankingLastYear} from "../constants/ranking";

export function getRankingItem(offerId: number) {
    const year = rankingLastYear.toString() as generalRankingKeysType;
    return generalRankings[year].find((rankingItem) => rankingItem.offerId === offerId);
}
